export function shallowCopyAndReplaceValueNullWithUndefined(src: object): object {
    const newObject = { ...src };
    Object.keys(newObject).forEach(function(key, index) {
        if (newObject[key] === null) {
            newObject[key] = undefined;
        }
    });
    return newObject;
}
